module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/circle--red-64363918d8648f75747ff1f9ef286f0c.png";